document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver((mutations, obs) => {
    const widgetWrapper = document.querySelector('.tp-widget-wrapper');
    if (widgetWrapper) {
      widgetWrapper.style.marginLeft = '0';
      widgetWrapper.style.marginRight = 'auto';
      widgetWrapper.style.textAlign = 'left';
      obs.disconnect();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const upsellForms = document.querySelectorAll('.hc-upsell-form');

  upsellForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => {
        return response.json().then(data => {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Unknown cart error.');
          }
          return data;
        });
      })
      .then(product => {
        if (typeof SHTHelper?.forceUpdateCartStatus === 'function') {
          SHTHelper.forceUpdateCartStatus(product);
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      })
      .catch(error => {
        alert('Error adding upsell product to cart:\n' + error.message);
      });
    });
  });

  document.querySelectorAll('.hc-select').forEach(select => {
    select.addEventListener('change', function () {
      const selectedVariantId = this.value;

      const form = this.closest('.hc-upsell-form');
      if (!form) return;

      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.value = selectedVariantId;
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-related").forEach(related => {
    related.addEventListener("click", function (e) {
      e.preventDefault();

      const trigger = this.querySelector(".hc-swatch-trigger");
      if (!trigger) return;

      const productId = trigger.getAttribute("data-product");
      const title = trigger.getAttribute("data-title");
      const price = trigger.getAttribute("data-price");
      const url = trigger.getAttribute("href");
      const image = trigger.getAttribute("data-image");
      const quick = trigger.getAttribute("data-quick");

      document.querySelectorAll(`.hc-related[data-product="${productId}"]`).forEach(el => {
        el.classList.remove("hc-related-active");
      });

      this.classList.add("hc-related-active");

      const link = document.querySelector(`.hc-link[data-product="${productId}"]`);
      if (link) {
        link.setAttribute("href", url);
        link.textContent = title;
      }

      const priceEl = document.querySelector(`.hc-price[data-product="${productId}"]`);
      if (priceEl) {
        priceEl.textContent = price;
      }

      const mediaWrapper = document.querySelector(`.card__media[data-product="${productId}"]`);
      if (mediaWrapper) {
        const mainImg = mediaWrapper.querySelector(".img-first");
        const hoverImg = mediaWrapper.querySelector(".img-second");

        if (mainImg) {
          mainImg.setAttribute("src", image);
          mainImg.setAttribute("srcset", image);
        }

        if (hoverImg) {
          hoverImg.setAttribute("src", image);
          hoverImg.setAttribute("srcset", image);
          hoverImg.classList.remove("opacity-100");
          hoverImg.classList.add("opacity-0");
        }
      }

      const quickBtn = document.querySelector(`.hc-quick-buy[data-product="${productId}"]`);
      if (quickBtn && quick) {
        quickBtn.setAttribute("data-product-url", quick);
      }
    });
  });
});